<div class="container-fluid">
  <div class="row mb-3">
    <div class="col-12">
      <h2>{{ 'MAILARCHIV.TITLE' | translate }}</h2>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="search()" class="mb-4">
    <div class="row g-2 align-items-end">
      <div class="col-md-6 col-lg-3">
        <app-form-select
          id="mail_account_ids"
          [formGroup]="form"
          controlName="mail_account_ids"
          [label]="'MAILARCHIV.MAIL_ACCOUNTS_FILTER'"
          [placeholder]="'MAILARCHIV.MAIL_ACCOUNTS_FILTER'"
          [options]="mailAccountOptions()"
          [optionLabelSelector]="[{ selector: 'name' }]"
          optionValueSelector="id"
          [multiple]="true"
          [clear]="true"
        />
      </div>
      <div class="col-md-6 col-lg-3">
        <app-form-input
          id="subject"
          [label]="'MAILARCHIV.SUBJECT'"
          controlName="subject"
          [formGroup]="form"
        />
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="d-flex gap-2 align-items-end flex-wrap">
          <div class="flex-grow-1 min-w-0">
            <app-form-select
              id="from"
              [formGroup]="form"
              controlName="from"
              [label]="'MAILARCHIV.FROM'"
              [placeholder]="'MAILARCHIV.FROM'"
              [options]="fromOptions()"
              [optionLabelSelector]="[{ selector: 'Address' }]"
              optionValueSelector="Address"
              [filter]="true"
              [clear]="true"
              [loading]="fromOptionsLoading()"
              (search)="loadFromOptions($event)"
              (opened)="loadFromOptions('')"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="d-flex gap-2 align-items-end flex-wrap">
          <div class="flex-grow-1 min-w-0">
            <app-form-select
              id="to"
              [formGroup]="form"
              controlName="to"
              [label]="'MAILARCHIV.TO'"
              [placeholder]="'MAILARCHIV.TO'"
              [options]="toOptions()"
              [optionLabelSelector]="[{ selector: 'Address' }]"
              optionValueSelector="Address"
              [filter]="true"
              [clear]="true"
              [loading]="toOptionsLoading()"
              (search)="loadToOptions($event)"
              (opened)="loadToOptions('')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2 align-items-end mt-2">
      <div class="col-md-4 col-lg-2">
        <app-datepicker
          id="since_date"
          [label]="'MAILARCHIV.SINCE'"
          controlName="since_date"
          [formGroup]="form"
        />
      </div>
      <div class="col-md-4 col-lg-2">
        <app-datepicker
          id="until_date"
          [label]="'MAILARCHIV.UNTIL'"
          controlName="until_date"
          [formGroup]="form"
        />
      </div>
      <div class="col-md-4 col-lg-2">
        <app-enum-select
          [formGroup]="form"
          controlName="spam_include"
          [enum]="spamIncludeOptions"
          [label]="'MAILARCHIV.SPAM_TOLERANCE'"
          [castFunction]="spamIncludeLabelKey"
        />
      </div>
      <div class="col-md-4 col-lg-2">
        <app-enum-select
          [formGroup]="form"
          controlName="date_order"
          [enum]="dateOrderOptions"
          [label]="'MAILARCHIV.DATE_ORDER'"
          [castFunction]="dateOrderLabelKey"
        />
      </div>
      <div class="col-md-4 col-lg-2 d-flex gap-2">
        <app-mdb-button
          [text]="'SEARCH'"
          color="primary"
          iconClass="fas fa-search"
          [isSubmit]="true"
          [loading]="loading()"
        />
        <app-mdb-button
          [text]="'MAILARCHIV.RESET'"
          color="warning"
          (onClick)="resetForm()"
        />
      </div>
    </div>
  </form>

  @if (searchResult() !== null || loading()) {
    @if (searchResult() !== null) {
      <div class="row mb-2">
        <div class="col">
          <p class="mb-0">{{ 'MAILARCHIV.HITS' | translate }}: {{ totalHits() }}</p>
        </div>
      </div>
    }

    <div class="table-responsive">
      <table class="table table-sm mt-4">
        <thead>
          <tr>
            <th scope="col">{{ 'MAILARCHIV.PREVIEW' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.EML' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.SUBJECT' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.FROM' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.TO' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.DATE' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.SPAM' | translate }}</th>
            <th scope="col">{{ 'MAILARCHIV.ATTACHMENTS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr>
              <td colspan="8" class="text-center py-4">
                <app-spinner></app-spinner>
                <span class="ms-2">{{ 'LOADING_RESULTS' | translate }}</span>
              </td>
            </tr>
          } @else if (searchResult() !== null && hits().length === 0) {
            <tr>
              <td colspan="8" class="text-center text-muted py-4">{{ 'NO_RESULTS_FOUND' | translate }}</td>
            </tr>
          } @else if (searchResult() !== null) {
            @for (row of hits(); track row.id) {
              <tr>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    (click)="togglePreview(row)"
                    [title]="isExpanded(row) ? ('MAILARCHIV.HIDE_PREVIEW' | translate) : ('MAILARCHIV.SHOW_PREVIEW' | translate)"
                  >
                    @if (isExpanded(row)) {
                      <i class="fas fa-eye-slash"></i>
                    } @else {
                      <i class="fas fa-eye"></i>
                    }
                  </button>
                </td>
                <td>
                  <a
                    href="#"
                    (click)="downloadEml(row.id, $event)"
                    class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-1"
                    [class.text-warning]="hasContentHit(row)"
                    [class.disabled]="isDownloadingEml(row.id)"
                    [attr.aria-busy]="isDownloadingEml(row.id)"
                    [attr.aria-disabled]="isDownloadingEml(row.id)"
                  >
                    @if (isDownloadingEml(row.id)) {
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
                    } @else {
                      <i class="fas fa-download"></i>
                    }
                  </a>
                </td>
                <td>
                  @if (hasSubjectHit(row)) {
                    <span class="subject" [innerHTML]="highlightSearchTerm(row.Subject, getControl('subject')?.value ?? '')"></span>
                  } @else {
                    {{ row.Subject ?? '' }}
                  }
                </td>
                <td>
                  @if (hasFromHit(row)) {
                    <span [innerHTML]="highlightSearchTerm(row.From, getFromHighlightTerm(row))"></span>
                  } @else {
                    {{ row.From ?? '' }}
                  }
                </td>
                <td>
                  @if (hasToHit(row)) {
                    <span [innerHTML]="highlightSearchTerm(row.To, getToHighlightTerm(row))"></span>
                  } @else {
                    {{ row.To ?? '' }}
                  }
                </td>
                <td>{{ formatMailDate(row) }}</td>
                <td>
                  @if ((row.Spam_Score ?? 0) > 4 && (row.Spam_Score ?? 0) <= 6) {
                    <i class="fas fa-exclamation-circle text-warning" [title]="row.Spam_Score"></i>
                  } @else if ((row.Spam_Score ?? 0) > 6) {
                    <i class="fas fa-exclamation-circle text-danger" [title]="row.Spam_Score"></i>
                  }
                </td>
                <td>
                  @if (row.Attachments?.length) {
                    @for (att of row.Attachments; track att) {
                      <span class="d-inline-flex align-items-center gap-1">
                        @if (isDownloadingAttachment(row.id, att)) {
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span class="text-muted">{{ att }}</span>
                        } @else {
                          <a
                            href="#"
                            (click)="downloadAttachment(row.id, att, $event)"
                            [class.text-warning]="getAttachmentHit(row, att)"
                          >{{ att }}</a>
                        }
                      </span><br />
                    }
                  }
                </td>
              </tr>
              @if (isExpanded(row)) {
                <tr>
                  <td colspan="8" class="bg-light p-3">
                    <pre class="mb-0 small text-break">{{ row.Text ?? '' }}</pre>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>

    @if (searchResult() !== null && !loading()) {
      <app-list-pagination-bar
        [meta]="paginationMeta"
        [perPageOptions]="perPageOptions"
        [loading]="loading()"
        selectId="per-page-mail-search"
        (perPageChange)="onPerPageChange($event)"
        (previousClicked)="paginationPrev()"
        (nextClicked)="paginationNext()"
      />
    }
  }
</div>
